import { Grid } from '@mui/material'
import React from 'react'
import Heading from './Heading'
import DropDown from './DropDown'
import SingleChoice from './SingleChoice'

const VoterDemographicsExitPoll = () => {



    const genderData = ['زن','مرد']



    const ageData = [
        '0-17',
        '18-24',
        '25-34',
        '35-44',
        '45-54',
        '55-64',
        '65 یا بیشتر',
    ]



    const salaryData = [
        '$0 - $24,999',
        '$25,000 - $49,999',
        '$50,000 - $74,999',
        '$75,000 - $99,999',
        '$100,000 - $149,999',
        '150 هزار دلار یا بیشتر',
    ]



    const educationData = [
        'کمتر از دیپلم ',
        'دبیرستان',
        'مقداری دانشگاه',
        'مدرک لیسانس',
        'مدرک تحصیلات تکمیلی',
    ]



    const politicalData = [
        'دموکرات',
        'جمهوری‌خواه',
        'مستقل',
    ]


    const voteData  = [
        {
            id: 1,
            label: "من",
            checked: false
        },
        {
            id: 2,
            label: " خودم ",
            checked: false
        },
        {
            id: 3,
            label: "ایرنه",
            checked: false
        },
    ]


    return (
        <Grid p={{ xs: '40px 13px', md: '40px 52px' }} bgcolor={'white'} borderRadius={'20px'} width={'100%'} maxWidth={'700px'} boxShadow={'0 4px 4px rgba(87,100,126,.21)'} m={{ xs: '72px 0px', md: '72px 42px' }}>
            <Heading header={'خروج از نظرسنجی'}  subHeader={'لطفا نظرسنجی خروج زیر را پر کنید'}/>
            <Grid className='states' display={'flex'} flexDirection={'column'} alignItems={'flex-start'} justifyContent={'flex-start'}>
                <DropDown header={'جنسیت'} options={genderData} />
                <DropDown header={'سن'} options={ageData} />
                <DropDown header={'درآمد خانوار'} options={salaryData} />
                <DropDown header={'سطح تحصیلات'} options={educationData} />
                <DropDown header={'دیدگاه سیاسی'} options={politicalData} />
                <SingleChoice header={'به کی رأی دادی؟'} options={voteData} />
            </Grid>
        </Grid>
    )
}

export default VoterDemographicsExitPoll
